module.exports = __webpack_public_path__ + "img/mysql.c3e4e003.png";